import "../styles/app.scss";

import FaBullets from "./modules/fa-bullets";
import HideNoNumber from "./modules/hide-no-number";
import TagLanguageSwitcher from "./modules/tag-language-switcher";

const fabullets = new FaBullets();
const hideNoNumber = new HideNoNumber();
const tagLanguageSwitcher = new TagLanguageSwitcher();